import { render, staticRenderFns } from "./ActionButtonsPOS.vue?vue&type=template&id=e536d856&scoped=true&"
import script from "./ActionButtonsPOS.vue?vue&type=script&lang=js&"
export * from "./ActionButtonsPOS.vue?vue&type=script&lang=js&"
import style0 from "./ActionButtonsPOS.vue?vue&type=style&index=0&id=e536d856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e536d856",
  null
  
)

export default component.exports